import { datef } from "@caredna-marlin/utils/dates";
import { Typography } from "@mui/material";
import { addDays, intervalToDuration, startOfDay } from "date-fns";
import LocationTooltip from "~/components/command/LocationTooltip";
import { CalendarBlockEventStatusEnum } from "~/graphql/__generated__/graphql";
import { LocalCalendarBlock } from "~/hooks/visitDragDropReducer";
import { StatusBgMap } from "~/utils/statuses";

type CalendarBlockEventProps = {
  date: Date;
  calendarBlock: LocalCalendarBlock;
  eventStatus: CalendarBlockEventStatusEnum;
};

const CalendarBlockBlocking: React.FC<CalendarBlockEventProps> = ({ date, calendarBlock, eventStatus }) => {
  const start = new Date(calendarBlock.startTime);
  const end = new Date(calendarBlock.endTime);

  const duration = (end && start) ? intervalToDuration({ start, end }) : {};

  // Partly transparent "cancelled" color, because full orange is way too bright for this purpose
  const canceled = StatusBgMap.canceled + '44';
  const background = eventStatus === CalendarBlockEventStatusEnum["Scheduled"] ? "#e5e5e5" : `repeating-linear-gradient(-45deg, #fff, #fff 11px, ${canceled} 11px, ${canceled} 22px)`;

  return (
    <div
      className="md-timeline-template-event"
      style={{
        color: "black",
        border: "1px dotted grey",
        fontSize: "13px",
        background,
      }}
    >
      <div className="md-timeline-template-event-cont">
        {start < startOfDay(date) && <Typography
          variant="body2"
          component="span"
          sx={{ fontWeight: "normal", mr: 3 }}
        >
          {"« "}{datef(start, "MMM d")}
        </Typography>}
        <Typography
          variant="body2"
          component="span"
          sx={{ fontWeight: "normal", mr: 1 }}
        >
          {calendarBlock.title || "Block"}
          {" - "}{duration.hours && `${duration.hours}hr${duration.hours > 1 ? 's' : ''}`}{duration.minutes && ` ${duration.minutes}min`}
        </Typography>
        {end > addDays(startOfDay(date), 1) && <Typography
          variant="body2"
          component="span"
          sx={{ fontWeight: "normal", ml: 3 }}
        >
          {datef(end, "MMM d")}{" »"}
        </Typography>}
        {calendarBlock.addressStreet && (
          <LocationTooltip address={{
            addressStreet: calendarBlock.addressStreet,
            addressCity: calendarBlock.addressCity,
            addressState: calendarBlock.addressState,
            addressZip: calendarBlock.addressZip
          }} />
        )}
      </div>
    </div>
  )
};

export default CalendarBlockBlocking
